module.exports = __webpack_public_path__ + "static/media/specialist.f110181e.jpg";